export default __webpack_public_path__ + "static/media/imperialdynamicscorp.c2498636.svg";